module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simulate"
  }, [_c('b-container', [_c('b-row', {
    staticClass: "simulate__title"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_vm._v("販売予測\n        "), (_vm.skuId) ? _c('span', {
    staticClass: "simulate__title__sub-info"
  }, [_vm._v("( SKU: " + _vm._s(_vm.skuId) + " )")]) : (_vm.itemId) ? _c('span', {
    staticClass: "simulate__title__sub-info"
  }, [_vm._v("( 品番: " + _vm._s(_vm.itemId) + " )")]) : _vm._e()])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "simulate__label"
  }, [_c('span', {
    staticClass: "simulate__label-circle simulate__label__legend-item blue"
  }, [_vm._v("●")]), _c('span', {
    staticClass: "simulate__label__legend-item"
  }, [_vm._v("実績")]), _vm._v(" "), _c('span', {
    staticClass: "simulate__label-circle simulate__label__legend-item cyan"
  }, [_vm._v("●")]), _c('span', {
    staticClass: "simulate__label__legend-item"
  }, [_vm._v("予測")]), _vm._v(" "), _c('span', {
    staticClass: "simulate__label-circle simulate__label__legend-item yellow"
  }, [_vm._v("●")]), _c('span', {
    staticClass: "simulate__label__legend-item"
  }, [_vm._v("カスタム予測")]), _vm._v(" "), _c('span', {
    staticClass: "simulate__label-circle simulate__label__legend-item gray"
  }, [_vm._v("●")]), _c('span', {
    staticClass: "simulate__label__legend-item"
  }, [_vm._v("累積入荷数")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "simulate__chart"
  }, [_c('b-col', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "simulate__chart-area",
    attrs: {
      "id": "chart-area"
    }
  }, [_c('chart', {
    staticStyle: {
      "position": "relative"
    },
    style: (_vm.cssGraphArea),
    attrs: {
      "height": 400,
      "chart-data": _vm.chartdata
    },
    on: {
      "render": _vm.createFixedScales
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "simulate__chart-box",
    style: (_vm.cssBoxAreaWidth)
  }, _vm._l((_vm.customOffrateWeek), function(offrate, idx) {
    return _c('div', {
      key: idx,
      staticClass: "simulate__chart-box--inputbox",
      style: (_vm.boxAreaMargin(idx))
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.customOffrateWeek[idx]),
        expression: "customOffrateWeek[idx]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "simulate__chart-box--inputbox--size",
      class: _vm.activeInput(idx) ? 'diact_input' : '',
      attrs: {
        "type": "number",
        "value": "customOffrateWeek[idx] >= 0 ? customOffrateWeek[idx] : '-'",
        "disabled": _vm.activeInput(idx)
      },
      domProps: {
        "value": (_vm.customOffrateWeek[idx])
      },
      on: {
        "keyup": [function($event) {
          return _vm.setAutoOffrate(idx)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.onCustomPredict($event)
        }],
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.customOffrateWeek, idx, _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "simulate__chart-box",
    style: (_vm.cssBoxAreaWidth)
  }, _vm._l((_vm.customArrivalWeek), function(arrival, idx) {
    return _c('div', {
      key: idx,
      staticClass: "simulate__chart-box--inputbox",
      style: (_vm.boxAreaMargin(idx))
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.customArrivalWeek[idx]),
        expression: "customArrivalWeek[idx]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "simulate__chart-box--inputbox--size",
      class: _vm.activeInput(idx) ? 'diact_input' : '',
      attrs: {
        "type": "number",
        "value": "customArrivalWeek[idx] >= 0 ? customArrivalWeek[idx] : '-'",
        "disabled": _vm.activeInput(idx)
      },
      domProps: {
        "value": (_vm.customArrivalWeek[idx])
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.onCustomPredict($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.customArrivalWeek, idx, _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])
  }), 0)], 1), _vm._v(" "), (_vm.itemId != 0) ? _c('div', {
    staticClass: "fixed-area"
  }, [_c('canvas', {
    attrs: {
      "id": "fixedScales",
      "width": 0,
      "height": 400
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fixed-area__label-group"
  }, [_c('div', {
    staticClass: "simulate__chart-box--label"
  }, [_vm._v("値引率")]), _vm._v(" "), _c('div', {
    staticClass: "simulate__chart-box--label"
  }, [_vm._v("入荷数")])])]) : _vm._e()])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('button', {
    staticClass: "simulate__button-custom",
    class: !_vm.itemId ? 'simulate__button-custom--diactive' : 'simulate__button-custom--active',
    attrs: {
      "disabled": !_vm.itemId
    },
    on: {
      "click": _vm.onCustomPredict
    }
  }, [_vm._v("セット\n        ")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-746a851e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./src/components/aftersale/predict/simulate/simulate.html
// module id = 700
// module chunks = 0